// extracted by mini-css-extract-plugin
export var attachment = "_rf-a";
export var emailContainer = "_rf-4";
export var emailContentPaddedContainer = "_rf-b";
export var emailHeader = "_rf-6";
export var emailIframe = "_rf-3";
export var emailInfoIcon = "_rf-9";
export var emailShortenedSummary = "_rf-e";
export var infoDropdown = "_rf-0";
export var infoRowBoundedContent = "_rf-d";
export var internal = "_rf-5";
export var merchant = "_rf-8";
export var messageInputContainer = "_rf-h";
export var normal = "_rf-7";
export var replyCard = "_rf-f";
export var subtleButton = "_rf-1";
export var subtleButtonIconContainer = "_rf-2";
export var toggleViewRepliesButton = "_rf-c";
export var wrappingText = "_rf-g";